import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SortingDirection } from '../../../../../../__legacy__/models/sortingDirection.model';
import { IProjectStatsFiltersStore } from '../../filters/ProjectStatsFilters.store';
import { IProjectStatsBl } from '../../ProjectStats.bl';
import { IProjectStatsStore } from '../../ProjectStats.store';
import { GeneralStatsTable } from './GeneralStatsTable';

export const GeneralStatsTableContainer = observer((): ReactElement => {
  const bl = useInjection(IProjectStatsBl.$);
  const filtersStore = useInjection(IProjectStatsFiltersStore.$);
  const store = useInjection(IProjectStatsStore.$);

  const handleOnSortChange = (orderBy: string, orderDirection: SortingDirection | undefined): void => {
    bl.changeGeneralStatsSorting(orderBy, orderDirection ?? SortingDirection.ASC);
  };

  const { visibleWorkers } = filtersStore;
  const { generalStats } = store;

  const items = generalStats.filter((s) => visibleWorkers.map((w) => w.id).includes(s.id));

  return (
    <GeneralStatsTable
      items={items}
      orderBy={store.generalStatsOrderBy}
      orderDirection={store.generalStatsOrderDirection}
      onSortChange={handleOnSortChange}
    />
  );
});
